import _rootRoutes from './root';

export const rootRoutes = _rootRoutes;
